// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeLogMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChangeLogMetadataQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, changeRequestGroups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string }>, enumDetails: { __typename?: 'AllEnumDetails', changeRequestStatus: Array<{ __typename?: 'ChangeRequestStatusDetail', code: Types.ChangeRequestStatus, name: string }>, changeType: Array<{ __typename?: 'ChangeTypeDetail', code: Types.ChangeType, name: string, sortOrder: number }>, businessFunctionType: Array<{ __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }>, changeRequestSource: Array<{ __typename?: 'ChangeRequestSourceDetail', code: Types.ChangeRequestSource, name: string }> } };

export type ChangeLogProjectFilterMetadataQueryVariables = Types.Exact<{
  filter: Types.ProjectFilter;
  page: Types.PageFilter;
}>;


export type ChangeLogProjectFilterMetadataQuery = { __typename?: 'Query', projectsPage: { __typename?: 'ProjectsPageResult', entities: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    > } };


export const ChangeLogMetadataDocument = gql`
    query ChangeLogMetadata {
  markets {
    id
    name
  }
  developments {
    id
    name
  }
  changeRequestGroups {
    id
    name
  }
  enumDetails {
    changeRequestStatus {
      code
      name
    }
    changeType {
      code
      name
      sortOrder
    }
    businessFunctionType {
      code
      name
    }
    changeRequestSource {
      code
      name
    }
  }
}
    `;

/**
 * __useChangeLogMetadataQuery__
 *
 * To run a query within a React component, call `useChangeLogMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeLogMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeLogMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useChangeLogMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>(ChangeLogMetadataDocument, options);
      }
export function useChangeLogMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>(ChangeLogMetadataDocument, options);
        }
// @ts-ignore
export function useChangeLogMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>;
export function useChangeLogMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeLogMetadataQuery | undefined, ChangeLogMetadataQueryVariables>;
export function useChangeLogMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>(ChangeLogMetadataDocument, options);
        }
export type ChangeLogMetadataQueryHookResult = ReturnType<typeof useChangeLogMetadataQuery>;
export type ChangeLogMetadataLazyQueryHookResult = ReturnType<typeof useChangeLogMetadataLazyQuery>;
export type ChangeLogMetadataSuspenseQueryHookResult = ReturnType<typeof useChangeLogMetadataSuspenseQuery>;
export type ChangeLogMetadataQueryResult = Apollo.QueryResult<ChangeLogMetadataQuery, ChangeLogMetadataQueryVariables>;
export const ChangeLogProjectFilterMetadataDocument = gql`
    query ChangeLogProjectFilterMetadata($filter: ProjectFilter!, $page: PageFilter!) {
  projectsPage(filter: $filter, page: $page, orderBy: {buildAddress: ASC}) {
    entities {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useChangeLogProjectFilterMetadataQuery__
 *
 * To run a query within a React component, call `useChangeLogProjectFilterMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeLogProjectFilterMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeLogProjectFilterMetadataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useChangeLogProjectFilterMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables> & ({ variables: ChangeLogProjectFilterMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables>(ChangeLogProjectFilterMetadataDocument, options);
      }
export function useChangeLogProjectFilterMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables>(ChangeLogProjectFilterMetadataDocument, options);
        }
// @ts-ignore
export function useChangeLogProjectFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables>;
export function useChangeLogProjectFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeLogProjectFilterMetadataQuery | undefined, ChangeLogProjectFilterMetadataQueryVariables>;
export function useChangeLogProjectFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables>(ChangeLogProjectFilterMetadataDocument, options);
        }
export type ChangeLogProjectFilterMetadataQueryHookResult = ReturnType<typeof useChangeLogProjectFilterMetadataQuery>;
export type ChangeLogProjectFilterMetadataLazyQueryHookResult = ReturnType<typeof useChangeLogProjectFilterMetadataLazyQuery>;
export type ChangeLogProjectFilterMetadataSuspenseQueryHookResult = ReturnType<typeof useChangeLogProjectFilterMetadataSuspenseQuery>;
export type ChangeLogProjectFilterMetadataQueryResult = Apollo.QueryResult<ChangeLogProjectFilterMetadataQuery, ChangeLogProjectFilterMetadataQueryVariables>;